
<div class="inline-block">
  <img v-if="hasImage && photoStatus == 'approved'" :class="`${sizeClasses} rounded-full`" :src="imageUrl" :alt="avatarAlt" />
  <div
    v-else-if="photoUploadIcon"
    aria-hidden="true"
    :class="`${sizeClasses} rounded-full bg-grey-divider-subdued text-grey-clickable font-medium flex items-center justify-center`"
  >
    <camera-outline :height="photoUploadDimensions.height" :width="photoUploadDimensions.width" />
  </div>
  <div
    v-else
    aria-hidden="true"
    :class="`${sizeClasses} rounded-full bg-grey-divider-subdued text-grey-clickable font-medium flex items-center justify-center`"
  >
    <span :class="textClasses">{{ placeholderInitials }}</span>
  </div>
</div>
